// Configuración de entorno para la aplicación
import { ENTORNO_ES_DESARROLLO } from './entorno'; // Palanca única: true=dev, false=prod
export const environment = {
  // Configuración del backend
  api: {
    baseURL: "https://app.grupobaudelet.com/api-em/v1.0/recursos/", // URL constante de producción
    timeout: parseInt(process.env.REACT_APP_API_TIMEOUT || "30000"), // tiempo de espera en ms
    devURL: "http://localhost:5000/api-em/v1.0/recursos/", // URL constante de desarrollo
  },
  
  // Configuración de la aplicación
  app: {
    name: process.env.REACT_APP_NAME || "El Mejor",
    version: process.env.REACT_APP_VERSION || "1.0.0",
    environment: process.env.NODE_ENV || "development",
  },
  
  // Configuración de autenticación
  auth: {
    tokenKey: "authToken",
    userKey: "userData",
  },
  
  // URLs importantes
  urls: {
    backend: "https://app.grupobaudelet.com/api-em/v1.0/recursos/",
    webApp: "https://appem.grupobaudelet.com",
    mainDomain: "https://grupobaudelet.com",
  }
};

// Función para verificar si estamos en desarrollo
export const isDevelopment = () => environment.app.environment === 'development';

// Función para obtener la URL del backend según el entorno (sin REACT_APP_*)
// hosts de la LAN que deben apuntar al backend de test cuando se accede por IP
const LAN_HOST_TO_DEV_URL: Record<string, string> = {
  '192.168.13.174': 'http://192.168.13.174:5000/api-em/v1.0/recursos/',
  '192.168.13.84': 'http://192.168.13.84:5000/api-em/v1.0/recursos/',
};

export const getBackendURL = () => { // devuelve la URL final del backend
  const host = (typeof window !== 'undefined' ? window.location.hostname : ''); // leer hostname actual del navegador
  if (host && LAN_HOST_TO_DEV_URL[host]) { // si abrimos la app usando la IP LAN
    return LAN_HOST_TO_DEV_URL[host]; // usar backend de test accesible por IP en la LAN
  }
  return ENTORNO_ES_DESARROLLO ? environment.api.devURL : environment.api.baseURL; // seleccionar por flag cuando no es IP LAN
};

// Función para verificar conectividad con el backend
export const checkBackendConnection = async (): Promise<boolean> => {
  try {
    const response = await fetch(`${getBackendURL()}frase_motivacional`); // usar la URL efectiva
    return response.ok; // true si responde 2xx
  } catch (error) {
    console.error('Error conectando al backend:', error);
    return false; // false ante errores de red
  }
}; 